import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PrivateModule } from './layouts/private/private.module';
import { PublicModule } from './layouts/public/public.module';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppInterceptor } from './providers/interceptors/app.interceptor';
import { ErrorModule } from './layouts/error/error.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_SELECT_CONFIG, MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PrivateModule,
    PublicModule,
    ErrorModule,
    LoadingBarHttpClientModule,
    MatSnackBarModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
    {
      // disableOptionCentering stops mat-select from measuring the panel + every
      // option and re-positioning the overlay so the selected option overlaps the
      // trigger on each open. That measure/reposition is a forced synchronous
      // reflow and the main cause of the 5-10s freeze when opening selects on iOS
      // WebKit. The panel now anchors below the trigger (like a native picker).
      provide: MAT_SELECT_CONFIG,
      useValue: { disableOptionCentering: true },
    },
    // The default select/autocomplete scroll strategy is `reposition`, which
    // recomputes the overlay position on every scroll event. On iOS WebKit a
    // momentum scroll with a panel open fires a stream of those recalcs, each a
    // reflow. NoopScrollStrategy leaves the open panel anchored and does nothing
    // on scroll. Safe here because these panels are short-lived pickers; the
    // token is providedIn:'root' and MatSelectModule doesn't re-provide it, so
    // this override reaches the lazy feature modules too.
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      useValue: () => new NoopScrollStrategy(),
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useValue: () => new NoopScrollStrategy(),
    },
    // Ripples run a JS-driven expand/fade animation on every press. Disabling
    // them globally removes that per-touch animation work on iOS WebKit (minor
    // visual loss). Easy to revert if it makes no measurable difference.
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: { disabled: true },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
